<template>

    <vs-table v-if="show" ref="table" :params="params" :options="options"></vs-table>

</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import PatternModal from "../../components/PatternModal.vue";
  import PsInput from "../../components/PsInput.vue";
  import PsNoneEditable from "../../components/PsNoneEditable.vue";
  import ProductsUnit from "../../components/ProductsUnit.vue";
  import SelectIntermediateProducts from "../../components/SelectIntermediateProducts.vue";
  import {mapState, mapMutations, mapActions} from "vuex";
  import EventBus from "../../bus.js";
  import ClientSelect from "../../components/ClientSelect.vue";

  export default {
    name: "patterns",
    components: {
      VsTable,
      SelectIntermediateProducts,
      PatternModal,
      PsInput,
      PsNoneEditable,
      ClientSelect,
      ProductsUnit
    },
    props: [],
    data() {
      return {
        access: {},
        isLoading: true,
        show: true,
        params: {
          entity: "products",
          list: [],
          headers: {
            productCode: {
              title: "کد محصول",
              type: "custom",
              component: PsInput,
              isSearchable: true,
              rowAlignment: "center"
            },
            productName: {
              title: "عنوان محصول",
              type: "custom",
              component: PsInput,
              isSearchable: true,
              rowAlignment: "center"
            },
            unit: {
              title: "واحد",
              type: "custom",
              isSearchable: false,
              component: ProductsUnit,
              multiple: false,
              label: "unitValue",
              rowAlignment: "center",
              inHeader: true,
              listParams: {
                requestURI: "units"
              }
            },
            stock: {
              title: "موجودی",
              type: "number",
              inHeader: false,
              rowAlignment: "center",
              mode: "view"
            },
            // price: {
            //   title: "قیمت",
            //   type: "number",
            //   inHeader: false,
            //   rowAlignment: "center"
            // },
            // persianDate: {
            //   title: "تاریخ تولید",
            //   type: "text",
            //   rowAlignment: "center"
            // },
            materials: {
              title: "محصولات میانی",
              type: "custom",
              component: PsNoneEditable,
              rowAlignment: "center",
              // multiple: true,
              // label: "productName",
              inHeader: true
              // listParams: {
              //   requestURI: "products"
              // }
            },
            productPattern: {
              title: 'الگوی تولید',
              type: 'custom',
              component: PatternModal,
              rowAlignment: 'center',
              inHeader: true
            }
          }
        },
        options: {
          hasActions: true,
          hasActionsInHeader: true,
          beforeCreateEntity: input => {
            if (input && input["materials"]) {
              input["materials"] = input["materials"].map(p => {
                return {
                  material: p.material.id,
                  percentage: p.percentage
                };
              });
            }
            if (input && input["unit"]) {
              input["unit"] = input["unit"].id || input["unit"];
            }
            this.refreshTable();
            return input;
          },
          beforeUpdateEntity: input => {
            if (input && input["materials"]) {
            }
            if (input && input["unit"]) {
              input["unit"] = input["unit"].id || input["unit"];
            }
            this.refreshTable();
            return input;
          },
          beforeFetchEntityList: input => {
            return input;
          },
          onRowClicked: row => {
            this.$emit("onRowSelect", row);
          },
          onRowDoubleClicked: row => {
            this.$emit("onRowDoubleClicked", row);
          },
          // onCreateHeaderActionClicked: () => {
          //   console.log("open modal");
          // }
          getTopRightButtons: () => {
            let arr = [];
            let searchToggleButton = {
              component: "search-toggle-button"
            };
            arr.push(searchToggleButton);
            return arr;
          },
          getTopLeftButtons: () => {
            let arr = [];
            let self = this;
            let addItemButton = {
              component: "toggle-table-actions-button",
              params: {
                onClick() {
                  self.options.hasActions = !self.options.hasActions;
                }
              }
            };
            let stackFilterButton = {
              component: "stock-filter-button"
            };
            arr.push(stackFilterButton);
            arr.push(addItemButton);

            return arr;
          }
        }
      };
    },
    beforeMount() {
      if (this.$route && this.$route.path) {
        this.options.access = checkAccess(this.$route.path);
      } else {
        this.options.access = checkAccess("works");
      }
      this.show = !!this.options.access;
    },
    mounted() {
      EventBus.$on("materialChanged", () => {
        this.refreshTable();
      });
    },
    computed: {
      ...mapState(["vsTableFeed"])
    },
    methods: {
      refreshTable() {
        this.show = false;
        this.isLoading = true;
        setTimeout(() => {
          this.isLoading =false;
          this.show = true;
        }, 200);
        this.$refs.table.onFetchEntityList();
      }
    },
    watch: {}
  };
</script>
